import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'
import { Link } from 'react-router-dom'
import { Typography } from '@mui/material'
import { prop } from 'ramda'
import { setIsCrisisModalOpen } from 'components/modals/modalSlice'
import { useDispatch, useSelector } from 'react-redux'
import CalloutBox from 'components/callout-box/CalloutBox'

const SubdomainCalloutBox = ({
  crisisSubdomain = false,
  topSectionCopy = null
}) => {
  const intl = useIntl()
  const { is_secondary_user } = useSelector(prop('user'))
  const dispatch = useDispatch()

  const schoolCopy = intl.formatMessage({
    defaultMessage:
      'The only mistake you can make is not reaching out. If you are seeking immediate support',
    id: 'pEA1Ex'
  })
  const defaultCopy = intl.formatMessage({
    defaultMessage: 'If you are seeking immediate support',
    id: 'hY33rf'
  })

  const getHelperCopy = () => {
    if (is_secondary_user) return schoolCopy
    return defaultCopy
  }

  const toggleCrisis = e => {
    e.preventDefault()
    dispatch(setIsCrisisModalOpen(true))
  }

  const getBottomCopy = () => {
    if (is_secondary_user)
      return (
        <FormattedMessage
          defaultMessage="When life gets hard, the only mistake you can make is not reaching out for support."
          id="WjeWj2"
        />
      )
    return (
      <FormattedMessage
        defaultMessage="When life gets hard, your campus community is here to help."
        id="EFNW3S"
      />
    )
  }

  const bottomCopy = (
    <>
      <Typography component="span" variant="body1">
        {getBottomCopy()}
      </Typography>
      <Typography component="span" id="help" sx={{ ml: 0.5 }} variant="body1">
        <FormattedMessage
          defaultMessage="{copy}, {resourceLink}."
          id="ywZQ/U"
          values={{
            copy: getHelperCopy(),
            resourceLink: (
              <Typography
                component={Link}
                onClick={e => toggleCrisis(e)}
                sx={{
                  textDecoration: 'underline'
                }}
                to=""
              >
                <FormattedMessage
                  defaultMessage="connect with crisis resources here"
                  id="gBYlUI"
                />
              </Typography>
            )
          }}
        />
      </Typography>
    </>
  )

  return (
    <CalloutBox
      bottomSectionCopy={crisisSubdomain ? bottomCopy : null}
      topSectionCopy={topSectionCopy}
    />
  )
}

SubdomainCalloutBox.propTypes = {
  crisisSubdomain: PropTypes.bool,
  topSectionCopy: PropTypes.string
}

export default SubdomainCalloutBox
